import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { SaleInvoiceDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import SaleInvoiceActivity from '../SaleInvoiceActivity'

interface SideContentProps {
  saleInvoice: SaleInvoiceDetailFragment
}

const SideContent = ({ saleInvoice }: SideContentProps) => {
  return (
    <>
      <SectionHeader title={i18n.t('finance.sale_invoices.detail.activity')} description={''} />
      <SaleInvoiceActivity events={saleInvoice.financialDocumentEvents} />
    </>
  )
}

export default SideContent
